"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BonusPercent = function () {
    var _a, _b;
    var data = (0, swr_hooks_1.useBonusesByType)(public_api_1.BonusType.Deposit).data;
    var config = (0, swr_hooks_1.useConfig)();
    if (!data || data.length === 0)
        return null;
    if (config.hideDepositBonusInHeader)
        return null;
    var percentFromFirstBonus = ((_b = (_a = data[0].rewards) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === public_api_1.BonusRewardType.Relative; })) === null || _b === void 0 ? void 0 : _b.relativePercent) || 0;
    if (!percentFromFirstBonus || percentFromFirstBonus === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("span", { className: styles_module_scss_1.default.text }, "".concat(percentFromFirstBonus, "%"))));
};
exports.default = BonusPercent;
